import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrLoaderComponent } from './pr-loader.component';
import { PrLoaderDirective } from './pr-loader.directive';

@NgModule({
  declarations: [PrLoaderComponent, PrLoaderDirective],
  imports: [CommonModule, PrIconModule],
  exports: [PrLoaderComponent, PrLoaderDirective],
})
export class PrLoaderModule {}
